var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 22C32 16.4771 27.5229 12 22 12C16.4771 12 12 16.4771 12 22C12 26.9912 15.6568 31.1283 20.4375 31.8785V24.8906H17.8984V22H20.4375V19.7969C20.4375 17.2906 21.9305 15.9062 24.2146 15.9062C25.3084 15.9062 26.4531 16.1016 26.4531 16.1016V18.5625H25.1922C23.95 18.5625 23.5625 19.3334 23.5625 20.125V22H26.3359L25.8926 24.8906H23.5625V31.8785C28.3432 31.1283 32 26.9912 32 22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b62d9a70cf81e6b597c68d4881029683.svg";
export { ForwardRef as ReactComponent };